var map = {
	"./auth/config": "830d",
	"./azmoon/config": "19ee",
	"./cooperation/config": "369a",
	"./fileManagement/config": "5fb1",
	"./home/config": "1ce8",
	"./interview/config": "3b4f",
	"./jobsProfile/config": "93c4",
	"./kanoon/config": "0d65",
	"./profile/config": "696c",
	"./report/config": "5265",
	"./research/config": "04f4",
	"./survey/config": "6327",
	"./task/config": "8f69",
	"./ticket/config": "501d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0555";